module.exports = __webpack_public_path__ + "img/5.bb5adeb6.png";